"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStudyYearDataByDate = exports.getStudyYearData = void 0;
var _dates = require("./dates");
const STUDY_YEAR_DATA = {
  startDay: 1,
  startMonth: 8,
  endDay: 31,
  endMonth: 7,
  semesters: {
    // 2 Semesters Dates
    2: {
      A: {
        startDay: 1,
        startMonth: 8,
        startYearOffset: 0,
        endDay: 31,
        endMonth: 1,
        endYearOffset: 1
      },
      B: {
        startDay: 1,
        startMonth: 2,
        startYearOffset: 1,
        endDay: 31,
        endMonth: 7,
        endYearOffset: 1
      }
    },
    // 3 Semesters Dates
    3: {
      A: {
        startDay: 1,
        startMonth: 8,
        startYearOffset: 0,
        endDay: 21,
        endMonth: 12,
        endYearOffset: 0
      },
      B: {
        startDay: 8,
        startMonth: 1,
        startYearOffset: 1,
        endDay: 1,
        endMonth: 4,
        endYearOffset: 1
      },
      C: {
        startDay: 18,
        startMonth: 4,
        startYearOffset: 1,
        endDay: 31,
        endMonth: 7,
        endYearOffset: 1
      }
    }
  }
};
const getStudyYearData = function (startYear) {
  let numOfSemesters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  const semestersData = STUDY_YEAR_DATA.semesters;
  const semesterData = semestersData[numOfSemesters];
  const studyYearSemesters = {};
  Object.entries(semesterData).forEach(_ref => {
    let [semesterKey, semester] = _ref;
    studyYearSemesters[semesterKey] = {
      ...semester,
      start: new Date(startYear + semester.startYearOffset, semester.startMonth - 1, semester.startDay, 0, 0, 0),
      end: new Date(startYear + semester.endYearOffset, semester.endMonth - 1, semester.endDay, 23, 59, 59)
    };
  });
  return {
    startYear,
    endYear: startYear + 1,
    title: `${startYear}/${startYear + 1}`,
    jewishTitle: (0, _dates.calcJewishYear)(startYear + 1),
    start: new Date(startYear, STUDY_YEAR_DATA.startMonth - 1, STUDY_YEAR_DATA.startDay, 0, 0, 0),
    end: new Date(startYear + 1, STUDY_YEAR_DATA.endMonth - 1, STUDY_YEAR_DATA.endDay, 23, 59, 59),
    semesters: studyYearSemesters
  };
};
exports.getStudyYearData = getStudyYearData;
const getStudyYearDataByDate = function () {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  let numOfSemesters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  let startYear = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const startYearStr = `${STUDY_YEAR_DATA.startMonth.toString().padStart(2, '0')}/${STUDY_YEAR_DATA.startDay.toString().padStart(2, '0')}`;
  const theDateStr = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`;
  if (startYearStr > theDateStr) {
    startYear--;
  }
  return getStudyYearData(startYear, numOfSemesters);
};
exports.getStudyYearDataByDate = getStudyYearDataByDate;